import { createFileRoute } from '@tanstack/react-router';

import { AuthLayout } from '@/components/layouts/AuthLayout';
import { StaffAuthBrandPanel } from '@/components/layouts/components/StaffAuthBrandPanel';
import { ForgotPasswordForm } from '@/features/auth/components/ForgotPasswordForm';

export const Route = createFileRoute('/forgot-password/')({ component: Page });

function Page() {
  return (
    <AuthLayout brandPanel={<StaffAuthBrandPanel />} formSide="left">
      <ForgotPasswordForm variant="staff" />
    </AuthLayout>
  );
}
